import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from '../../styles/theme'
import { Box, Typography } from '@mui/material'

export const BoxOverview = ({
  textBox,
  numberBox,
  numberCaptionBox,
}: {
  textBox: string
  numberBox: number
  numberCaptionBox: number
}) => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        m="20px"
        sx={{
          padding: '12px',
          width: 145,
          height: 130,
          textAlign: 'center',
          borderRadius: '10px',
          border: '1px solid #F8F8F8',
          backgroundColor: 'common.white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          '&:hover': {
            backgroundColor: 'grey.200',
          },
        }}
      >
        <Typography variant="h6" component="h6">
          {textBox}
        </Typography>
        <Typography
          fontWeight="700"
          variant="h1"
          component="h1"
          color={theme.palette.grey[600]}
        >
          {numberBox}
        </Typography>
        <Box
          m="0 30px"
          sx={{
            padding: '4px',
            borderRadius: '20px',
            backgroundColor: 'grey.200',
          }}
        >
          <Typography variant="h6" component="h6" fontWeight="700">
            {numberCaptionBox}
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  )
}
